import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.463 13.755a.625.625 0 0 1-.923 0L6.207 10.11a.625.625 0 1 1 .922-.843l2.247 2.457V2.5a.625.625 0 0 1 1.25 0v9.224l2.247-2.458a.625.625 0 0 1 .923.843z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.125 12.5a.625.625 0 1 0-1.25 0v.046c0 1.14 0 2.058.097 2.78.101.75.317 1.382.818 1.884.502.501 1.133.717 1.884.818.722.097 1.64.097 2.78.097h5.092c1.14 0 2.058 0 2.78-.097.75-.1 1.382-.317 1.884-.818.501-.502.717-1.133.818-1.884.097-.722.097-1.64.097-2.78V12.5a.625.625 0 1 0-1.25 0c0 1.196-.001 2.03-.086 2.66-.082.611-.233.935-.463 1.166s-.555.38-1.166.463c-.63.085-1.464.086-2.66.086h-5c-1.196 0-2.03-.001-2.66-.086-.611-.082-.935-.233-1.166-.463s-.38-.555-.463-1.166c-.085-.63-.086-1.464-.086-2.66"
    }, null, -1)
  ]))]))
}
export default { render: render }